import { IconeSeta } from '@/components/atoms/Icones/IconeSeta';
import * as S from './styles';
import { useTheme } from 'styled-components';
import Link from '@/components/atoms/Link';
import { ComponentType, CSSProperties, Fragment } from 'react';
import { IconeCasa } from '@/components/atoms/Icones/IconeCasa';
import { IconProps } from '@/types/icon';

export type BreadcrumbLink = {
  href: string;
  texto: string;
  atual: boolean;
  Icone?: ComponentType<IconProps>;
};
export type BreadcrumbsProps = {
  links: Array<BreadcrumbLink>;
  style?: CSSProperties;
  linkDefault?: BreadcrumbLink;
};

export default function Breadcrumbs(props: BreadcrumbsProps) {
  const { linkDefault = undefined, links, style = {} } = props;
  const formatedLinks: Array<BreadcrumbLink> = [
    linkDefault ?? {
      href: '/',
      texto: 'Página Inicial',
      atual: false,
      Icone: IconeCasa,
    },
    ...links,
  ];
  const theme = useTheme();

  return (
    <S.Container style={style}>
      {formatedLinks?.map((link, index) => (
        <Fragment key={link.href + index}>
          {link?.Icone ? (
            <link.Icone
              size={16}
              color={
                link.atual
                  ? theme.tokens.colors.white_contrast
                  : theme.colors.neutral.neutral[11]
              }
            />
          ) : null}
          <Link
            $size={1}
            $color="neutral"
            $weight="regular"
            $underline={false}
            $highContrast={link.atual}
            $active={!link.atual}
            $text={link.texto}
            href={link.href}
            style={{ lineHeight: 0 }}
          />
          {index < formatedLinks.length - 1 && (
            <IconeSeta
              direcao="direita"
              size={16}
              color={theme.colors.neutral.neutral[11]}
            />
          )}
        </Fragment>
      ))}
    </S.Container>
  );
}
